import { combineReducers } from "@reduxjs/toolkit";
import registerReducer from "../controller/Register/Register";

const rootReducer = combineReducers({
  register: registerReducer,
});

export default rootReducer;
